import axios from 'axios';
import api from '@app/utils/api';
import qs from 'qs';

export const sendInvite = (body) => {
  return api.post('/owner/send-invite', body);
};

export const sendInviteLink = (body) => {
  const payloadFormData = new FormData();
  Object.keys(body).map((itemKey) => {
    payloadFormData.append(itemKey, body[itemKey]);
    return itemKey;
  });

  return axios
    .post(
      'https://prod-70.westeurope.logic.azure.com:443/workflows/2debc3256bcb42dbbc66a27de78f6a52/triggers/manual/paths/invoke?api-version=2016-06-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=VfuhjVjnL0KOtsTHlsp0kYo2Fkk1DkUuoOSeDfwQDr4',
      payloadFormData
    )
    .then((result) => {
      return result;
    })
    .catch((err) => {
      // console.log('Error while posting link to third party url', err);
      return err;
    });
};

export const fetchInvites = (params) => {
  const qParams = qs.stringify(params);
  return api.get(`/owner/send-invite?${qParams}`);
};
